import { render, staticRenderFns } from "./RewardsOverview.vue?vue&type=template&id=0ea0f554&scoped=true"
import script from "./RewardsOverview.vue?vue&type=script&lang=js"
export * from "./RewardsOverview.vue?vue&type=script&lang=js"
import style0 from "./RewardsOverview.vue?vue&type=style&index=0&id=0ea0f554&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea0f554",
  null
  
)

export default component.exports